import React, { useEffect, useRef } from "react";
import brush from "./../../images/brush.png"; // import brush image as a module
import "./ScratchZone.css";
import scratchImage from "../../images/GratteStadeMontois.jpg";

import { sendMail } from "../../api/apiCall";

const ScratchZone = ({ config, setShow, loading, win }) => {
  const canvasRef = useRef(null);
  const ctxRef = useRef(null);
  const lastPointRef = useRef(null);
  const isDrawingRef = useRef(false);
  const brushRef = useRef(null);

  useEffect(() => {
    if (!config) return;
    console.log("config component", config);
    const canvas = canvasRef.current;
    canvas.width = canvas.parentElement.offsetWidth;
    canvas.height = canvas.parentElement.offsetHeight;

    const ctx = canvas.getContext("2d");
    ctxRef.current = ctx;

    brushRef.current = new Image();
    brushRef.current.src = brush;

    const cover = new Image();
    cover.src = scratchImage;
    // canvas.width = cover.width;
    // canvas.height = cover.height;
    // cover.crossOrigin = "Anonymous"; // Add this line
    // cover.src = config.scratchImg;
    canvas.width = canvas.parentElement.offsetWidth;
    canvas.height = canvas.parentElement.offsetHeight;

    // const scaleX = canvas.width / cover.width;
    // const scaleY = canvas.height / cover.height;

    cover.onload = () => {
      ctx.drawImage(cover, 0, 0, canvas.width, canvas.height);
    };

    canvas.addEventListener("mousedown", touchStart, { passive: false });
    canvas.addEventListener("touchstart", touchStart, { passive: false });
    canvas.addEventListener("mousemove", touchMove, { passive: false });
    canvas.addEventListener("touchmove", touchMove, { passive: false });
    canvas.addEventListener("mouseup", touchEnd);
    canvas.addEventListener("touchend", touchEnd);

    return () => {
      canvas.removeEventListener("mousedown", touchStart);
      canvas.removeEventListener("touchstart", touchStart);
      canvas.removeEventListener("mousemove", touchMove);
      canvas.removeEventListener("touchmove", touchMove);
      canvas.removeEventListener("mouseup", touchEnd);
      canvas.removeEventListener("touchend", touchEnd);
    };
  }, [config]);

  const getPosition = (event) => {
    const target = canvasRef.current;
    const rect = target.getBoundingClientRect();
    const x =
      (event.pageX || event.touches[0].clientX) - rect.left - target.clientLeft;
    const y =
      (event.pageY || event.touches[0].clientY) - rect.top - target.clientTop;
    return { x, y };
  };

  const touchStart = (event) => {
    isDrawingRef.current = true;
    lastPointRef.current = getPosition(event);
    ctxRef.current.globalCompositeOperation = "destination-out";
  };

  const touchMove = (event) => {
    if (!isDrawingRef.current) return;
    event.preventDefault();

    const ctx = ctxRef.current;
    const a = lastPointRef.current;
    const b = getPosition(event);
    const dist = Math.sqrt(Math.pow(b.x - a.x, 2) + Math.pow(b.y - a.y, 2));
    const angle = Math.atan2(b.x - a.x, b.y - a.y);
    const offsetX = brushRef.current.width / 2;
    const offsetY = brushRef.current.height / 2;

    for (let x, y, i = 0; i < dist; i++) {
      x = a.x + Math.sin(angle) * i - offsetX;
      y = a.y + Math.cos(angle) * i - offsetY;
      ctx.drawImage(brushRef.current, x, y);
    }

    lastPointRef.current = b;

    // Calculate the percentage of the canvas that has been erased
    const imageData = ctx.getImageData(
      0,
      0,
      canvasRef.current.width,
      canvasRef.current.height
    );
    const data = imageData.data;
    let transparentPixels = 0;
    for (let i = 3; i < data.length; i += 4) {
      if (data[i] === 0) {
        transparentPixels++;
      }
    }
    const totalPixels = canvasRef.current.width * canvasRef.current.height;
    const percentageErased = (transparentPixels / totalPixels) * 100;
    if (percentageErased > 80) {
      setShow(true);
    }
  };

  const touchEnd = (event) => {
    isDrawingRef.current = false;
  };

  return (
    <div className="scratchParent">
      <div className="scratchArea">
        <canvas
          style={{
            position: "absolute",
            zIndex: 2,
            width: "100%",
            height: "100%",
          }}
          ref={canvasRef}
        />
        {!loading ? (
          <div>
            <div className="secret absolute fill no-select flex justify-center items-center">
              {win ? config.textWin : config.textLoose}
            </div>
          </div>
        ) : null}
      </div>
    </div>
  );
};

export default ScratchZone;
